import { COMMA_WITH_OPTIONAL_SPACE } from './constants';
import { assertObject, isFunction, isObject, isString } from './typeChecks';

var getEnumerableSymbols = obj => {
  if (!isFunction(Object.getOwnPropertySymbols)) {
    return [];
  }

  return Object.getOwnPropertySymbols(obj).filter(sym => {
    return Object.getOwnPropertyDescriptor(obj, sym).enumerable;
  });
};

var deepMergeObjects = function deepMergeObjects(target) {
  assertObject(target);

  for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    objects[_key - 1] = arguments[_key];
  }

  if (!objects.length) {
    return target;
  }

  var obj = objects[0];

  if (isObject(target) && isObject(obj)) {
    var properties = [...Object.keys(obj), ...getEnumerableSymbols(obj)];
    properties.forEach(prop => {
      if (isObject(obj[prop])) {
        if (!isObject(target[prop])) {
          target[prop] = {};
        }

        deepMergeObjects(target[prop], obj[prop]);
      } else {
        Object.assign(target, {
          [prop]: obj[prop]
        });
      }
    });
  }

  return deepMergeObjects(target, ...objects.slice(1));
};

var ILLEGAL_TYPES = [undefined, null];

var hasOwnProp = (o, props) => {
  if (ILLEGAL_TYPES.includes(o)) {
    return false;
  }

  var propsArray = props;

  if (isString(props)) {
    propsArray = props.split(COMMA_WITH_OPTIONAL_SPACE);
  } else if (!Array.isArray(props)) {
    propsArray = [props];
  }

  return propsArray.every(prop => {
    return Object.prototype.hasOwnProperty.call(o, prop);
  });
};

var invert = obj => {
  assertObject(obj);
  var inverted = {};
  Object.entries(obj).forEach(_ref => {
    var [key, val] = _ref;
    inverted[val] = key;
  });
  return inverted;
};

export { deepMergeObjects, hasOwnProp, invert };